export default [

  {
    "text": "Pointeuses",
    "route": "pointeusesadmin",
    "icon": "ti-devices",
    "permission": "Voir la page des pointeuses"
  },

  {
    "text": "Entreprises",
    "route": "entreprises",
    "icon": "ti-briefcase",
    "permission": "Voir la page des pointeuses"
  },

  {
    "text": "LICENCES",
    "icon": "ti-key",
    "route": "licences",
    "permission": "Voir la page d'acceuil",
    "modules": "Licences"
  },

  {
    "text": "Support Clients",
    "icon": "ti-headset",
    "route": "",
    "submenu": [

      {
        "text": "Requettes",
        "icon": "ti-message-plus",
        "route": "supportclientrequettes",
        "params": {
          "type": "journal"
        },
        "permission": "Voir la page des pointages brutes"
      },

      {
        "text": "Reponses",
        "icon": "ti-message",
        "route": "supportclientreponses",
        "params": {
          "type": "journal"
        },
        "permission": "Voir la page des pointages brutes"
      }

    ]
  },

  {
    "text": "Configurations",
    "icon": "ti-settings",
    "route": "configurations",
    "permission": "Voir la page de Configurations",
    "module": "Configuration"
  },

  {
    "text": "Administration utilisateurs",
    "icon": "ti-user",
    "route": "",
    "module": "Administration",
    "submenu": [

      {
        "text": "Utilisateurs",
        "route": "users",
        "icon": "ti-user",
        "permission": "Voir la page des utilisateurs"
      },

      {
        "text": "Les super admin",
        "route": "Users_SU",
        "icon": "ti-crown",
        "permission": "Voir la page des superAdmin",
        "isSu": true
      },

      {
        "text": "Roles / Profils",
        "route": "roles",
        "icon": "ti-id-badge",
        "params": {
          "type": "brute"
        },
        "permission": "Voir la page des roles"
      },

      {
        "text": "Permissions",
        "route": "permissions",
        "icon": "ti-key",
        "isSu": true,
        "params": {
          "type": "brute"
        },
        "permission": "Voir la page des permissions"
      },

      {
        "text": "Logs",
        "route": "surveillances",
        "icon": "ti-eye",
        "permission": "Voir la page des activites recentes"
      },

      {
        "text": "Entreprises",
        "route": "entreprises",
        "icon": "ti-building",
        "isSu": true
      }

    ]
  }

]
